/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

import { Injectable } from '@angular/core';
import { SSLCipherList } from '../../../models';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class CipherListService {
    private userCipherListsEmitter: Subject<any> = new Subject<any>();

    constructor() {
    }

    /**
     *
     * @param cipherList
     */
    public updateUserCipherLists(cipherList: SSLCipherList[]) {
        this.userCipherListsEmitter.next(cipherList);
    }

    /**
     *
     */
    public getUserCipherList(): Observable<any> {
        return this.userCipherListsEmitter.asObservable();
    }
}
